export const getWWPitaBreadPackage = newProduct => {
  let newWWPitaBreadPackage = {
    UPC: newProduct.UPC,
    Size: newProduct.Size,
    WholeWheatCert: newProduct.WholeWheatCert,
  }

  return newWWPitaBreadPackage
}

export const updateWWPitaBreadPackage = newProduct => {
  let newWWPitaBreadPackage = {
    UPC: newProduct.UPC,
    Size: newProduct.Size,
    WholeWheatCert: newProduct.WholeWheatCert,
  }

  return newWWPitaBreadPackage
}
